export default {
  name: 'Pagination',
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    }
  },
  data() {
    return {};
  },
  components: {},
  computed: {
    computedRoute() {
      return this.$route;
    },
    computedQuery() {
      let { query } = this.$route;
      let allowedAttrs = ['orderby', 'filters'];
      let strictQuery = {};
      if (Object.keys(query).length) {
        strictQuery = Object.keys(query).reduce((acc, key) => {
          if (allowedAttrs.indexOf(key) > -1) {
            return { ...acc, [key]: query[key] };
          }
          return acc;
        }, {});
        console.log('computedQuery', { query, strictQuery });
      }
      return strictQuery;
    },
    routeName() {
      let { name } = this.$route;
      return name.replace('-paginated', '');
    },
    prevPage() {
      if (this.currentPage > 1) {
        let { params } = this.$route;

        return {
          name: this.currentPage - 1 === 1 ? this.routeName : `${this.routeName}-paginated`,
          params: {
            ...params,
            page: this.currentPage - 1
          },
          query: this.computedQuery
        };
      }

      return null;
    },
    visiblePages() {
      const pages = [];
      const total = this.totalPages;
      const current = this.currentPage;

      if (total < 8) {
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
      } else {
        for (let i = 1; i <= Math.min(3, total); i++) {
          pages.push(i);
        }

        if (current > 4) {
          pages.push('...');
        }

        const start = Math.max(4, current - 1);
        const end = Math.min(total - 3, current + 1);
        for (let i = start; i <= end; i++) {
          pages.push(i);
        }

        if (end < total - 3) {
          pages.push('... ');
        }

        for (let i = Math.max(total - 2, end + 1); i <= total; i++) {
          pages.push(i);
        }
      }

      return pages;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        let { params } = this.$route;

        return {
          name: `${this.routeName}-paginated`,
          params: {
            ...params,
            page: this.currentPage + 1
          },
          query: this.computedQuery
        };
      }
      return null;
    }
  },
  mounted() {},
  methods: {}
};
